@app.directive 'madlib', (authenticationService, $rootScope, $state, csAdwords, csFacebookConversion, AnalyticsService, ModalService, formHelper, LocationService) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'banner'
  controller: ($scope) ->
    LocationService.loadData()

    @showPassword = false
    @showSuccess = false
    @showMadlib = false
    @showSpinner = false

    if $state.currentUser
      @showMadlib = false
      AnalyticsService.track 'Madlib Not Shown', {url: $state.current.url}
    else
      @showMadlib = true
      AnalyticsService.track 'Madlib Shown', {url: $state.current.url}

    @togglePassword = ->
      AnalyticsService.track 'Madlib Toggled Password', {url: $state.current.url}
      @showPassword = !@showPassword

    @isInUS = ->
      LocationService.isInUS()

    @showErrorFor = (fieldName, validationParam) =>
      formHelper.showErrorFor(@bannerForm, fieldName, validationParam)

    @submit = =>

      registrationSuccess = =>
        AnalyticsService.track 'Madlib Registration Success', {url: $state.current.url}
        csAdwords.track(998032928,'77TfCIjjrAgQoIzz2wM')
        csFacebookConversion.track(6014798030226,0.00)

        # Mixpanel
        properties = {source : @source, method: 'standard'}
        AnalyticsService.track 'Signed Up JS', properties

        # Google Analytics
        AnalyticsService.track 'Complete', { category: 'Sign Up' }

        @showSuccess = true
        @showMadlib = false
        @showSpinner = false

        ModalService.open('ftue')
        $state.reload()

      registrationError = =>
        console.log @bannerForm
        AnalyticsService.track 'Madlib Registration Error', {url: $state.current.url}
        $rootScope.$emit 'New Alert', {type: 'error', message: 'An error occured while registering your account.'}
        @showSpinner = false

      if @bannerForm.$valid
        AnalyticsService.track 'Madlib Form Submitted', {url: $state.current.url}
        @showSpinner = true
        authenticationService
          .registerWithEmail @bannerForm.name.$modelValue, @bannerForm.email.$modelValue, @bannerForm.password.$modelValue, (@bannerForm.optout?.$modelValue||false)
          .then registrationSuccess, registrationError

    @successClose = =>
      @showSuccess = false

    $scope.$watch 'banner.bannerForm.$dirty', (newValue, oldValue) ->
      if newValue
        AnalyticsService.track 'Madlib Form Dirty', {url: $state.current.url}

    $scope.$watch 'banner.bannerForm.$valid', (newValue, oldValue) ->
      if newValue
        AnalyticsService.track 'Madlib Submit Button Active', {url: $state.current.url}

    this


  bindToController: {
    theme: '='
    content: '='
    source: '='
  }
  templateUrl: "/assets/templates/components/banner/bannerMadlib/madlib.html"
